var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExperience1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 16,
    viewBox: "0 0 22 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.22833 5.88068V3.56924C6.22833 2.95621 6.47186 2.36829 6.90534 1.93482C7.33881 1.50134 7.92673 1.25781 8.53976 1.25781H13.1626C13.7757 1.25781 14.3636 1.50134 14.7971 1.93482C15.2305 2.36829 15.4741 2.95621 15.4741 3.56924V5.88068M1.60547 12.815L5.24597 13.7245C8.92617 14.6444 12.7762 14.6444 16.4564 13.7245L20.0969 12.815",
    stroke: "url(#paint0_linear_157_648)",
    strokeWidth: 2.31143,
    strokeLinecap: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_157_648",
    x1: 10.8512,
    y1: 1.25781,
    x2: 10.8512,
    y2: 14.4144,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9C1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E80505"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExperience1);
export default __webpack_public_path__ + "static/media/experience1.ef196d7b919f32af2e88cc4585b41217.svg";
export { ForwardRef as ReactComponent };